import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ProveDiFedelta = () => {
  const { t } = useTranslation();

  return (
    <div className="prove-fedelta-page">
      <div className="top-bar" />

      <section className="prove-hero-full">
        <div className="prove-bokeh-bg" style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1514214460829-5f081763862a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxib2tlaCUyMGxpZ2h0c3xlbnwwfHx8fDE3NzcyOTE4MTN8MA&ixlib=rb-4.1.0&q=85')`,
        }}></div>

        <div className="prove-hero-box">
          <h1 className="prove-title-wix">{t('prove.title')}</h1>
          <p className="prove-text-wix">{t('prove.heroText')}</p>
          <p className="prove-final-wix">{t('prove.heroFinal')}</p>
        </div>
      </section>

      <section className="prove-content-elegant">
        <div className="prove-elegant-container">

          <div className="prove-split-section">
            <h2 className="prove-mobile-title">{t('prove.sectionTitle')}</h2>
            <div className="prove-split-image" style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.15), rgba(0,0,0,0.15)), url('https://customer-assets.emergentagent.com/job_preview-live-18/artifacts/y76yvnix_9eb42102f89299f282d2cfeacfbce761.jpg')`,
            }}>
              <div className="prove-image-overlay">
                <h2 className="prove-elegant-title">{t('prove.sectionTitle')}</h2>
              </div>
            </div>

            <div className="prove-split-content">
              <div className="prove-text-elegant">
                <p className="prove-lead">{t('prove.lead')}</p>
                <p>{t('prove.p1')}</p>
              </div>
            </div>
          </div>

          <div className="prove-full-box">
            <p>{t('prove.p2')}</p>
            <p>{t('prove.p3')}</p>
          </div>

          <div className="prove-cta-elegant">
            <div className="prove-cta-content-new">
              <p className="prove-cta-quote-new">{t('prove.ctaQuote')}</p>
              <p className="prove-signature-new">{t('prove.ctaSignature')}</p>
              <Link to="/contatti" className="btn-black-elegant">
                <span>{t('prove.ctaBtn')}</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default ProveDiFedelta;
